"use strict";

module.exports = function (file) {
  return require('@/views/' + file).default;
}; // vue-loader at least v13.0.0+